// src/stone/icons/StoneAgentShakingHands2X.tsx
import { jsx } from "react/jsx-runtime";
var StoneAgentShakingHands2X = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M7.5 4.333a3.167 3.167 0 1 0 0 6.334 3.167 3.167 0 0 0 0-6.334M2.334 7.5a5.167 5.167 0 1 1 10.333 0 5.167 5.167 0 0 1-10.333 0M32.5 4.333a3.167 3.167 0 1 0 0 6.334 3.167 3.167 0 0 0 0-6.334M27.334 7.5a5.167 5.167 0 1 1 10.333 0 5.167 5.167 0 0 1-10.333 0M2.424 17.424a6 6 0 0 1 4.243-1.757c2.823 0 4.65 1.542 6.127 3.023.263.264.508.518.744.763.458.476.886.92 1.354 1.339.684.613 1.353 1.072 2.096 1.324a1 1 0 0 1-.642 1.894c-1.1-.373-2.003-1.025-2.789-1.729-.52-.467-1.038-1.003-1.527-1.51a57 57 0 0 0-.652-.669c-1.4-1.404-2.73-2.435-4.711-2.435a4 4 0 0 0-4 4v14h8v-9a1 1 0 0 1 2 0v10a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-15a6 6 0 0 1 1.757-4.243M26.443 22.281c-.786.704-1.688 1.356-2.788 1.73a1 1 0 0 1-.643-1.895c.743-.252 1.412-.711 2.096-1.324.468-.42.896-.863 1.354-1.339.237-.245.481-.5.744-.763 1.477-1.48 3.304-3.023 6.128-3.023a6 6 0 0 1 6 6v15a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-10a1 1 0 1 1 2 0v9h8v-14a4 4 0 0 0-4-4c-1.982 0-3.311 1.03-4.712 2.435-.21.21-.428.437-.652.67-.489.506-1.006 1.042-1.527 1.51" })
  }
);
var StoneAgentShakingHands2X_default = StoneAgentShakingHands2X;

export {
  StoneAgentShakingHands2X,
  StoneAgentShakingHands2X_default
};
